import { FC, Dispatch, SetStateAction } from 'react'
import { DefaultTitle, DefaultSubtitle, RadioButtonsContainer } from '../../../components/application/defaultComponents'
import { InsuranceTypeData } from '../../../dtos/applicationData'
import ImgRadio from '../../../components/basic/ImgRadio'
import LawyerImg from '../../../assets/applicationFormsImgs/lawyer.svg'
import JudgeImg from '../../../assets/applicationFormsImgs/judge.svg'

interface InsuranceTypeProps {
  insuranceType: InsuranceTypeData;
  setInsuranceType: Dispatch<SetStateAction<InsuranceTypeData>>
}

const InsuranceType: FC<InsuranceTypeProps> = ({ insuranceType, setInsuranceType }) => {
  return (
    <>
      <DefaultTitle>What type of insurance are you looking for?</DefaultTitle>
      <DefaultSubtitle>Please select an option below.</DefaultSubtitle>
      <RadioButtonsContainer>
        <ImgRadio 
          value="LAWYER" 
          onChange={e => setInsuranceType(e.target.value as InsuranceTypeData)} 
          checked={insuranceType === 'LAWYER'}
          label="Lawyer"
        >
          <img src={LawyerImg} alt="lawyer" />
        </ImgRadio>
        <ImgRadio 
          value="JUDGE" 
          onChange={e => setInsuranceType(e.target.value as InsuranceTypeData)} 
          checked={insuranceType === 'JUDGE'}
          label="Judge"
        >
          <img src={JudgeImg} alt="lawyer" />
        </ImgRadio>
      </RadioButtonsContainer>
    </>
  )
}

export default InsuranceType